export default __webpack_public_path__ + "static/media/onhold.75b0255d.svg";